import { resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 md:grid-cols-3 gap-7" }
const _hoisted_2 = { class: "grid grid-cols-1 md:grid-cols-2 gap-7 mt-7" }
const _hoisted_3 = {
  key: 0,
  class: "mt-4 mb-4"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_card_kpi = _resolveComponent("card-kpi")!
  const _component_card_group = _resolveComponent("card-group")!

  return (_ctx.bounceData)
    ? (_openBlock(), _createBlock(_component_card_group, {
        key: 0,
        title: _ctx.$t('pages.mails.bounceAnalytics')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_card_kpi, {
              header: _ctx.$t('pages.mails.bounceReputation'),
              value: _ctx.bounceData.reputation_score || 0,
              loading: _ctx.loading,
              tooltip: _ctx.$t('pages.mails.tooltips.bounceReputation')
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  name: 
                            _ctx.bounceData.reputation_status === 'excellent'
                                ? 'CheckCircle'
                                : _ctx.bounceData.reputation_status === 'good'
                                ? 'ExclamationCircle'
                                : 'XCircle'
                        ,
                  class: _normalizeClass(_ctx.reputationIconColor)
                }, null, 8, ["name", "class"])
              ]),
              _: 1
            }, 8, ["header", "value", "loading", "tooltip"]),
            _createVNode(_component_card_kpi, {
              header: _ctx.$t('pages.mails.hardBounceRate'),
              text: 
                    `${((_ctx.bounceData.hard_bounce_rate || 0)).toFixed(1)}%`
                ,
              loading: _ctx.loading,
              tooltip: _ctx.$t('pages.mails.tooltips.hardBounceRate')
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  name: "PencilAlt",
                  class: "text-red-500"
                })
              ]),
              _: 1
            }, 8, ["header", "text", "loading", "tooltip"]),
            _createVNode(_component_card_kpi, {
              header: _ctx.$t('pages.mails.softBounceRate'),
              text: 
                    `${((_ctx.bounceData.soft_bounce_rate || 0)).toFixed(1)}%`
                ,
              loading: _ctx.loading,
              tooltip: _ctx.$t('pages.mails.tooltips.softBounceRate')
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  name: "PencilAlt",
                  class: "text-yellow-500"
                })
              ]),
              _: 1
            }, 8, ["header", "text", "loading", "tooltip"])
          ]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_card_kpi, {
              header: _ctx.$t('pages.mails.complaintRate'),
              text: 
                    `${((_ctx.bounceData.complaint_rate || 0)).toFixed(1)}%`
                ,
              loading: _ctx.loading,
              tooltip: _ctx.$t('pages.mails.tooltips.complaintRate')
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  name: "PencilAlt",
                  class: "text-orange-500"
                })
              ]),
              _: 1
            }, 8, ["header", "text", "loading", "tooltip"]),
            _createVNode(_component_card_kpi, {
              header: _ctx.$t('pages.mails.problemContacts'),
              value: _ctx.bounceData.problem_contacts_count || 0,
              loading: _ctx.loading,
              tooltip: _ctx.$t('pages.mails.tooltips.problemContacts')
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_app_icon, {
                  name: "Users",
                  class: "text-gray-500"
                })
              ]),
              _: 1
            }, 8, ["header", "value", "loading", "tooltip"])
          ]),
          (
                _ctx.bounceData.recommendations && _ctx.bounceData.recommendations.length
            )
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bounceData.recommendations, (rec, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(["p-3 rounded-lg text-sm", 
                    rec.type === 'success'
                        ? 'bg-green-50 text-green-800'
                        : rec.type === 'warning'
                        ? 'bg-yellow-50 text-yellow-800'
                        : 'bg-red-50 text-red-800'
                ])
                  }, _toDisplayString(_ctx.getTranslatedRecommendation(rec.message)), 3))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["title"]))
    : _createCommentVNode("", true)
}